import React from 'react'
import { ResourceProps } from './types'
import { Description, Icon, Location, LocationText, ResourceWrapper, Title } from './styles'
import { SingleGallery } from '../SingleGallery'
import { LocationOn } from '@mui/icons-material'

export const Resource: React.FC<ResourceProps> = ({
  resourceId,
  name,
  description,
  images,
  isAdmin = false,
  onClick,
  location,
}) => {
  if (location) {
  const parts = location.split(", ");
  var result = parts[2]

  if (parts[2] === "N/A" || parts[2] === "Sin edificio asignado") {
    result = parts[1]
  }
}

  // const limitedDescription = description.length > 80 ? description.substring(0, 70) + "..." : description;

  return (
    // loadingPlace ? (
      <ResourceWrapper onClick={onClick}>
        {isAdmin ? (
          <SingleGallery images={images} width='100%' height='100%' resourceId={resourceId} />
        ) : (
          <SingleGallery images={images} width='100%' height='100%' favorite resourceId={resourceId} />
        )}
        <Title>{name}</Title>
        <Description>{description}</Description>
        <Location>
          <Icon>
            <LocationOn sx={{fontSize: '16px'}}/>
          </Icon>
          <LocationText>{result}</LocationText>
        </Location>
      </ResourceWrapper>
  //   ) : (
  //     <ResourceSkeleton />
  //   )
  );
  
}

export default Resource
